import React, { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

import MainPageTableHeader from "../../layout/body/MainPageTableHeader";
import MainPageHOC from "../../layout/hoc/MainPageHOC";

import { PaginationComponent } from "../../components/Component";
import FetcherComponent from "../../components/shared/FetcherComponent";
import MainPageHeader from "../../components/shared/MainPageHeader";
import VacanciesPageTableBody from "../../components/vacancyPage/VacanciesPageTableBody";

import vacancyService from "../../services/vacancyService";
import { useVacancyPageContext } from "../../hooks/useVacancyPageContext";

const VacanciesPage = () => {
  const {
    vacancies,
    setVacancies,
    currentPage,
    setCurrentPage,
    totalPages,
    setTotalPages,
    totalRecords,
    setTotalRecords,
    setPageSize,
    pageSize,
  } = useVacancyPageContext();

  const [searchParams] = useSearchParams();
  const currentPageQueryString = searchParams.get("current-page");
  const pageSizeQueryString = searchParams.get("page-size");

  const fetchVacancies = useCallback(
    async () =>
      await vacancyService.getVacancies({
        currentPage: currentPageQueryString,
        pageSize: pageSizeQueryString,
      }),
    [currentPageQueryString, pageSizeQueryString]
  );

  const handleOnLoadFetchedVacancies = useCallback(
    (res) => {
      setVacancies(res?.data);
      // API sahifani 0 dan sanaydi.
      setCurrentPage((res?.currentPage ?? 0) + 1);
      setTotalPages(res?.totalPages);
      setTotalRecords(res?.totalRecords);
      setPageSize(res?.pageSize);
    },
    [setVacancies, setCurrentPage, setTotalPages, setTotalRecords, setPageSize]
  );

  return (
    <MainPageHOC
      headerTitle={"Vacancies"}
      pageHeader={
        <MainPageHeader
          totalRecords={totalRecords}
          pageName="Vacancies"
          redirectTo={"create"}
          showAddButton={true}
        />
      }
      tableHeader={
        <MainPageTableHeader pageSize={pageSize} setPageSize={setPageSize} />
      }
      tableBody={
        <FetcherComponent
          key={[currentPageQueryString, pageSizeQueryString]
            .filter(Boolean)
            .join("-")}
          action={fetchVacancies}
          onLoad={handleOnLoadFetchedVacancies}
        >
          <>
            {vacancies?.length > 0 ? (
              <VacanciesPageTableBody />
            ) : (
              <div className="d-flex justify-content-center align-items-center py-5">
                <h5 className="title text-soft">No data found</h5>
              </div>
            )}

            <PaginationComponent
              currentPageNumber={currentPage}
              totalPages={totalPages}
              totalRecords={totalRecords}
              status={pageSizeQueryString}
            />
          </>
        </FetcherComponent>
      }
    />
  );
};

export default VacanciesPage;
